
import {HttpClient} from '@angular/common/http';
import {Inject, Injectable, DOCUMENT} from '@angular/core';
import {BaseSiteService, GlobalMessageService, GlobalMessageType, RoutingService, WindowRef} from '@spartacus/core';
import {LoginFormComponentService} from '@spartacus/user/account/components';
import {Observable, of} from 'rxjs';
import {AimoAuthRedirectService} from '../../../service/auth/aimo-auth-redirect.service';
import {AimoAuthService} from '../../../service/auth/aimo-auth.service';
import {openCloseSpinner} from '../../shared/utils/spinner/aimo-spinner-utils';

@Injectable()
export class AimoLoginFormComponentService extends LoginFormComponentService {
    constructor(
        protected auth: AimoAuthService,
        protected globalMessage: GlobalMessageService,
        protected winRef: WindowRef,
        protected routingService: RoutingService,
        protected authRedirectService: AimoAuthRedirectService,
        protected baseSiteService: BaseSiteService,
        @Inject(DOCUMENT) private document: Document,
        protected http: HttpClient,
    ) {
        super(auth, globalMessage, winRef);
    }

    public isCDCLoginActivated(oldLogin: boolean): Observable<boolean> {
        if (oldLogin) {
            return of(false);
        }
        return this.auth.isCDCLoginActivated();
    }

    public forwardToCLPLoginPage(): void {
        this.auth.forwardToCDCLoginPage(false);
    }

    protected onSuccess(isLoggedIn: boolean): void {
        if (isLoggedIn) {
            // We want to remove error messages on successful login (primary the bad username/password combination)
            this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
            // this.form.reset();
            this.authRedirectService.aimoRedirect();
            openCloseSpinner(this.document, false);
        }
        this.busy$.next(false);
    }
}
